import { reduce } from "lodash/core";
export default {
  data() {
    return {
      options: {}
    };
  },
  methods: {
    getQueryOptions(options = null) {
      let { options: stateOptions, filters } = this;
      const mapedFilters = reduce(
        filters,
        (result, item, key) => {
          if (item) result[key] = item;
          return result;
        },
        {}
      );
      const { sortBy, sortDesc, itemsPerPage, page } = options || stateOptions;
      const sort = (sortBy || []).reduce((result, item, index) => {
        result.push([item, sortDesc[index] ? "desc" : "asc"]);
        return result;
      }, []);

      return { filters: mapedFilters, sort, limit: itemsPerPage, page };
    }
  }
};
